<template>
  <BasePill
    :text="text"
    :hoverable="hoverable"
    :selected="selected"
    :size="size"
    :theme="theme"
    :class="`variant-${variant}`"
  />
</template>

<script>
import BasePill from '@/components/library/pills/BasePill.vue';

const sizes = [
  'normal',
  'large',
];

const variants = {
  complete: {
    defaultContainerClasses: 'variant-complete',
    defaultCircleClasses: 'bg-bulkSendStatus-complete',
    defaultTextClasses: 'text-dark3',
    hoverContainerClasses: 'border-bulkSendStatusDark-complete hover:bg-bulkSendStatusLight-complete',
    hoverCircleClasses: 'group-hover:bg-bulkSendStatus-complete',
    hoverTextClasses: 'group-hover:text-dark3',
    selectedContainerClasses: 'border-bulkSendStatus-complete bg-bulkSendStatus-complete',
    selectedCircleClasses: 'bg-whiteOverride',
    selectedTextClasses: 'text-dark3',
  },
  draft: {
    defaultContainerClasses: 'variant-draft',
    defaultCircleClasses: 'bg-bulkSendStatus-draft',
    defaultTextClasses: 'text-dark3',
    hoverContainerClasses: 'border-bulkSendStatusDark-draft hover:bg-bulkSendStatusLight-draft',
    hoverCircleClasses: 'group-hover:bg-bulkSendStatus-draft',
    hoverTextClasses: 'group-hover:text-dark3',
    selectedContainerClasses: 'border-bulkSendStatus-draft bg-bulkSendStatus-draft',
    selectedCircleClasses: 'bg-whiteOverride',
    selectedTextClasses: 'text-dark3',
  },
  processing: {
    defaultContainerClasses: 'variant-processing',
    defaultCircleClasses: 'bg-bulkSendStatus-processing',
    defaultTextClasses: 'text-dark3',
    hoverContainerClasses: 'border-bulkSendStatusDark-processing hover:bg-bulkSendStatusLight-processing',
    hoverCircleClasses: 'group-hover:bg-envelopeStatus-processing',
    hoverTextClasses: 'group-hover:text-dark3',
    selectedContainerClasses: 'border-bulkSendStatus-processing bg-bulkSendStatus-processing',
    selectedCircleClasses: 'bg-whiteOverride',
    selectedTextClasses: 'text-whiteOverride',
  },
  failed: {
    defaultContainerClasses: 'variant-failed',
    defaultCircleClasses: 'bg-bulkSendStatus-failed',
    defaultTextClasses: 'text-dark3',
    hoverContainerClasses: 'border-bulkSendStatusDark-failed hover:bg-bulkSendStatusLight-failed',
    hoverCircleClasses: 'group-hover:bg-bulkSendStatus-failed',
    hoverTextClasses: 'group-hover:text-dark3',
    selectedContainerClasses: 'border-bulkSendStatus-failed bg-bulkSendStatus-failed',
    selectedCircleClasses: 'bg-whiteOverride',
    selectedTextClasses: 'text-whiteOverride',
  },
};

export default {
  name: 'BulkSendsStatusPill',
  components: {
    BasePill,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator(value) {
        return Object.keys(variants).includes(value);
      },
    },
    text: {
      type: String,
      required: true,
    },
    hoverable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator(value) {
        return sizes.includes(value);
      },
    },
  },
  computed: {
    theme() {
      return variants[this.variant];
    },
  },
};
</script>
